import React, { ChangeEvent } from "react";
import { Button } from "../../common/component/Button";
import GlyphIcons from "../../common/constants/GlyphIcons";
import ItemList from "./ItemList";
import { escapeRegExp } from "../../common/util/StringUtil";
import Filter from "../../common/component/Filter";
import DataSetFilterItem from "../../filter/DataSetFilter/dto/DataSetFilterItem";

interface ItemLookUpProps {
    enabled: boolean;
    className: string;
    id: string;
    title: string;
    items: DataSetFilterItem[];
    filterMessage: string;
    onClose: () => void;
    onAdd?: (filterId: string) => void;
}
interface ItemLookUpState {
    filter: string;
    items: DataSetFilterItem[];
    position: {
        pageSize: number;
        totalPages: number;
        pageNumber: number;
        startItem: number;
        endItem: number;
    };
    filteredItems: DataSetFilterItem[];
}
class ItemLookUp extends React.Component<ItemLookUpProps, ItemLookUpState> {
    constructor(props: ItemLookUpProps) {
        super(props);

        this.state = {
            filter: "",
            items: [],
            position: {
                pageSize: 10,
                totalPages: 0,
                pageNumber: 1,
                startItem: 0,
                endItem: 0,
            },
            filteredItems: [],
        };
    }

    UNSAFE_componentWillReceiveProps(newProps: ItemLookUpProps) {
        const filteredItems: DataSetFilterItem[] = this.filterAndSortItems(newProps.items, this.state.filter);
        const position = this.calculateItemsPosition(
            filteredItems.length,
            this.state.position && this.state.position.pageSize,
            this.state.position.pageNumber
        );
        this.setState({
            filteredItems: filteredItems,
            position: position,
        });
    }

    render() {
        if (!this.props.enabled) {
            return null;
        }

        return (
            <div className={`itemLookUp ${this.props.className}`} id={`${this.props.id}`}>
                <h4 className={"itemLookUpHeader"}>
                    <div className={"itemLookUpTitle"}>{this.props.title}</div>
                    <Button
                        id={this.props.id + "CloseButton"}
                        className={"panelHeaderButton"}
                        onClick={this.props.onClose}
                        tooltip={"Close"}
                        glyph={GlyphIcons.CLOSE}
                        disabled={false}
                    />
                </h4>

                <Filter
                    id={this.props.id + "Filter"}
                    placeholder={this.props.filterMessage}
                    onChange={this.handleFilterChanged.bind(this)}
                    value={this.state.filter}
                />

                <ItemList
                    id={this.props.id}
                    visibleItems={this.state.filteredItems}
                    className={this.props.className}
                    onPageChange={this.handlePageChanged.bind(this)}
                    position={this.state.position}
                    onAdd={this.props.onAdd}
                    hiddenItems={[]}
                />
            </div>
        );
    }

    filterAndSortItems(allCalculations: DataSetFilterItem[], filterString: string) {
        const filter = new RegExp(".*" + escapeRegExp(filterString) + ".*", "i");
        return allCalculations
            ? allCalculations
                  .filter((calculation) => !filter || filter.test(calculation.name))
                  .sort((a, b) => a.id - b.id)
            : [];
    }

    handleFilterChanged(event: ChangeEvent<HTMLInputElement>) {
        const filteredItems = this.filterAndSortItems(this.props.items, event.target.value);
        const pageNumber =
            filteredItems.length !== this.props.items.length || filteredItems.length === 0
                ? 1
                : this.state.position.pageNumber;

        const position = this.calculateItemsPosition(
            filteredItems.length,
            this.state.position && this.state.position.pageSize,
            pageNumber
        );
        this.setState({
            filter: event.target.value,
            filteredItems: filteredItems,
            position: position,
        });
    }

    calculateItemsPosition(itemCount: number, pageSize: number, pageNumber: number) {
        const totalPages = Math.ceil(itemCount / pageSize);

        let startItem = (pageNumber - 1) * pageSize;
        let endItem = startItem + pageSize;

        if (startItem >= itemCount) {
            pageNumber = Math.max(pageNumber - 1, 1);
            startItem = (pageNumber - 1) * pageSize;
        }

        return {
            pageSize: pageSize,
            totalPages: totalPages,
            pageNumber: pageNumber,
            startItem: startItem,
            endItem: endItem,
        };
    }

    handlePageChanged(pageNumber: number) {
        this.setState({
            position: this.calculateItemsPosition(
                this.state.filteredItems.length,
                this.state.position.pageSize,
                pageNumber
            ),
        });
    }
}

export default ItemLookUp;
